import AppLayout from "@cloudscape-design/components/app-layout"
import { Outlet } from "react-router-dom"
import Footer from "../Footer/Footer"
import Header from "../Header/Header"
import ToastContainer from "../Notifications/ToastContainer"

const Layout = () => {
  return (
    <>
      <Header />
      <AppLayout
        headerSelector="#top-nav"
        footerSelector="#app-footer"
        navigationHide
        maxContentWidth={Number.MAX_SAFE_INTEGER}
        notifications={<ToastContainer />}
        toolsHide
        content={<Outlet />}
      />
      <Footer />
    </>
  )
}

export default Layout
